// @flow
import React from 'react';
import { MdChevronRight } from 'react-icons/md';

type Props = {
  classname?: string,
  click: Function,
  background: string,
  width: number,
  height: number,
  color: string,
};

const ArrowRight = ({ classname, click, background, width, height, color }: Props) => {
  if (process.env.APP_ENV !== 'server' && typeof window === 'object') {
    const isSafari = () => {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('safari') !== -1) {
        return ua.indexOf('chrome') <= -1;
      }
      return false;
    };

    return (
      <MdChevronRight
        className={isSafari() ? `${classname} safari` : classname}
        onClick={click}
        style={{ background, width, height, color }}
      />
    );
  }

  return (
    <MdChevronRight
      className={classname}
      onClick={click}
      style={{ background, width, height, color }}
    />
  );
};

export default ArrowRight;



// WEBPACK FOOTER //
// ./src/components/common/Arrow/ArrowRight.js